export default __webpack_public_path__ + "static/media/ApplePayLogo.39b55d34.svg";